import * as React from 'react';

import AddIcon from '@mui/icons-material/Add';
import BottomNavigation from '@mui/material/BottomNavigation';
import BottomNavigationAction from '@mui/material/BottomNavigationAction';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import { amber } from '@mui/material/colors';
import Grid from '@mui/material/Grid';
import ListAltIcon from '@mui/icons-material/ListAlt';
import PeopleIcon from '@mui/icons-material/People';

// Styles
import { useTheme } from '@mui/material/styles';

import MyRequests from './myrequests/MyRequests';
import RequestForm from './newrequest/RequestForm';
import LodgeUse from './lodgeuse/LodgeUse';
import SignupsOffline from './SignupsOffline';
import UsageStatistics from './statistics/UsageStatistics';

// Responsive hooks
import { useResponsive } from '../hooks/UseResponsive';

// Redux
import { useAppDispatch, useAppSelector } from '../hooks/UseReduxState'
import { getMemberRequestSaved, setMemberRequestSaved } from '../../redux/requestSlice'

enum Nav {
  MyRequests = 0,
  LodgeUse = 1,
  NewRequest = 2,
  Usage = 3
}

interface SignupsProps {
  signupsOffline: boolean;
  signupsStartTime: string;
}

const Signups: React.FC<SignupsProps> = (props: SignupsProps) => {

  const { isMobile } = useResponsive();

  const [activeNav, setActiveNav] = React.useState(Nav.MyRequests);

  // Redux
  const dispatch = useAppDispatch();
  const memberSaved: boolean = useAppSelector(getMemberRequestSaved);

  // #region Styles

  const theme = useTheme();
  const styles = {
    nav: {
      borderBottom: `1px solid ${theme.palette.divider}`,
      flexGrow: 1,
      margin: theme.spacing(1, 0, 1, 0)
    },
    requirements: {
      border: `1px solid ${theme.palette.divider}`,
      margin: theme.spacing(1, 0, 1, 0),
      padding: theme.spacing(1, 2, 1, 2),
      backgroundColor: amber[300]
    },
    requirementsText: {
      padding: theme.spacing(0, 0, 0, 0)
    },
    waiversNeededContainer: {
      padding: theme.spacing(1, 0, 0, 0)
    },
  };

  // #endregion

  // #region Event Handlers

  /*
   * Handle change in nav option
   */
  const handleNavChange = (event: React.ChangeEvent<{}>, navIndex: number) => {
    setActiveNav(navIndex);
  };

  React.useEffect(() => {
    if (isMobile) {
      setActiveNav(Nav.MyRequests);
    } else {
      setActiveNav(Nav.MyRequests);
    }
  }, [isMobile]);

  React.useEffect(() => {
    if (memberSaved) {
      dispatch(setMemberRequestSaved(false));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [memberSaved]);

  // #endregion

  return (
    <>
      {(props.signupsOffline) &&
        <SignupsOffline
          signupsStartTime={props.signupsStartTime}
        />
      }
      {(!props.signupsOffline && !isMobile) &&
        <>
          <Grid container size={12}>
            <BottomNavigation
              value={activeNav}
              onChange={handleNavChange}
              showLabels
              sx={styles.nav}
            >
              <BottomNavigationAction value={Nav.MyRequests} label="My Requests" icon={<PeopleIcon />} />
              <BottomNavigationAction value={Nav.LodgeUse} label="Lodge Use" icon={<CalendarTodayIcon />} />
              <BottomNavigationAction value={Nav.NewRequest} label="New Request" icon={<AddIcon />} />
              <BottomNavigationAction value={Nav.Usage} label="Usage Statistics" icon={<ListAltIcon />} />
            </BottomNavigation>
          </Grid>
          <Grid container size={12} justifyContent="center">
            {activeNav === Nav.MyRequests &&
              <MyRequests />
            }
            {activeNav === Nav.NewRequest &&
              <RequestForm />
            }
            {activeNav === Nav.LodgeUse &&
              <LodgeUse />
            }
            {activeNav === Nav.Usage &&
              <Grid container>
                <UsageStatistics />
              </Grid>
            }
          </Grid>
        </>
      }
      {(!props.signupsOffline && isMobile) &&
        <>
          <Grid container>
            <BottomNavigation
              value={activeNav}
              onChange={handleNavChange}
              showLabels
              sx={styles.nav}
            >
              <BottomNavigationAction value={Nav.MyRequests} label="My Requests" icon={<PeopleIcon />} />
              <BottomNavigationAction value={Nav.LodgeUse} label="Lodge Use" icon={<CalendarTodayIcon />} />
              <BottomNavigationAction value={Nav.NewRequest} label="New Request" icon={<AddIcon />} />
            </BottomNavigation>
          </Grid>
          <Grid container>
            {activeNav === Nav.MyRequests &&
              <MyRequests />
            }
            {activeNav === Nav.LodgeUse &&
              <LodgeUse />
            }
            {activeNav === Nav.NewRequest &&
              <RequestForm />
            }
          </Grid>
        </>
      }
    </>
  );
}

export default Signups;
